import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import { ClaimHeader } from '../components/claimHeader';
import { SignupAuth } from '../components/signupAuth';

export const SignUp = ({ activeNetwork, company, isOnboarding }) => (
  <Flex sx={{ width: '360px', mt: '200px', gap: '56px', flexDirection: 'column' }}>
    <ClaimHeader activeNetwork={activeNetwork} company={company} />
    <SignupAuth domain={company?.domain} activeNetwork={activeNetwork} company={company} isOnboarding={isOnboarding} />
  </Flex>
);

SignUp.propTypes = {
  activeNetwork: PropTypes.object.isRequired,
  company: PropTypes.object,
  isOnboarding: PropTypes.bool,
};

SignUp.defaultProps = {
  company: null,
  isOnboarding: false,
};
